import Vue from 'vue'

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS
//////////////////////////////////////////////////////////////// Cookies Message
import CookiesMsg from './plugins/cookies-msg/index.js'
Vue.use(CookiesMsg)

//////////////////////////////////////////////////////////////// Site Drawer
import SiteDrawer from './plugins/site-drawer/index.js'
Vue.use(SiteDrawer)

//////////////////////////////////////////////////////////////// Bootstrap Modal
import {
    ModalPlugin
} from 'bootstrap-vue'
Vue.use(ModalPlugin)

//////////////////////////////////////////////////////////////// Vue Sticky Directive
import Sticky from 'vue-sticky-directive'
Vue.use(Sticky)

//////////////////////////////////////////////////////////////// Scroll To
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    container: "body",
    duration: 750,
    easing: "ease",
    offset: -120,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS
//////////////////////////////////////////////////////////////// Background Image
import BgImage from './components/bg-image/index.vue'
Vue.component('BgImage', BgImage)

//////////////////////////////////////////////////////////////// Text Wings
import TextWings from './components/text-wings/index.vue'
Vue.component('TextWings', TextWings)

/////////////////////////////////////////////////////////////////////////////////////////////////// DIRECTIVES
//////////////////////////////////////////////////////////////// Gsap
import Gsap from './directives/gsap/index.js'
Vue.directive('Gsap', Gsap)

/////////////////////////////////////////////////////////////////////////////////////////////////// App Components
//////////////////////////////////////////////////////////////// Background Image
import StickyElement from './components/sticky-element/index.vue'
const ExperienceTabs = () => import('./experience-tabs.js')
const PeoplePage = () => import('./people-page.js')
const GoogleMap = () => import('./google-map.vue')

// import {
//     devices
// } from './imports/utils'

var app = new Vue({
    el: '#app',
    components: {
        StickyElement,
        ExperienceTabs,
        PeoplePage,
        GoogleMap
    },
    data() {
        return {
            lang: document.getElementById('app').getAttribute('lang'),
            // isDevice: devices(),
            windowWidth: window.innerWidth,
            scrollTop: window.scrollY
        }
    },
    methods: {
        onResize() {
            this.windowWidth = window.innerWidth
        },
        onScroll() {
            this.scrollTop = window.scrollY
        }
    },
    created() {
        window.addEventListener("resize", this.onResize, {
            passive: false
        });

        window.addEventListener('scroll', this.onScroll, {
            passive: false
        });

        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;')
    },
    destroyed() {
        window.removeEventListener("resize")
    }
})